/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_NoteInputs */

const vi_shop_contact_note = /** @type {(inputs: Shop_Contact_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng chung cho web (header, footer, trang Liên hệ), Mini App (gọi / Zalo / Cần hỗ trợ) và email gửi khách.`)
};

/**

* @param {Shop_Contact_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_note = /** @type {((inputs?: Shop_Contact_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_note(inputs)
});